<template src="./index.html"></template>

<script>
import mixin from "@/mixins/index";
import { URL, apiCall } from "@/utils/api";
export default {
  name: "NotificationPanel",
  mixins: [mixin],
  props: { visible: Boolean },
  data() {
    return {
      notifications: [],
      problems: [],
    };
  },
  methods: {
    seeAll() {
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "notifications",
        params: { all: true, limit: 50, offset: 0 },
      }).then((response) => {
        if (!response.data.error) {
          this.notifications = response.data.data;
        }
      });
    },
    getNotifications() {
      if (this.currentStep.hasNotification) {
        apiCall({
          url:
            URL[process.env.NODE_ENV].service_api + "problems/hasNotification",
          method: "GET",
          params: {
            all: true,
          },
        })
          .then((response) => {
            if (!response.data.error) this.problems = response.data.data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    checkAllRead() {
      apiCall({
        url: URL[process.env.NODE_ENV].service_api + "notifications/read",
        method: "PUT",
      }).then((response) => {
        if (!response.data.error) {
          this.notifications.forEach((item) => (item.read = true));
          this.$emit("change");
        }
      });
    },
    goPage(notification) {
      this.checkRead(notification);
      window.location.href = "/problems/" + notification.problemId;
    },
    checkRead(notification) {
     
      apiCall({
        url:
          URL[process.env.NODE_ENV].service_api +
          "notifications/" +
          notification.id,
        method: "PATCH",
      }).then((response) => {
        if (!response.data.error) {
          notification.read = true;
          this.$emit("change");
        }
      });
    },
  },
  watch: {
    visible: function (newValue, oldValue) {
      if (newValue) {
        this.getNotifications();
      }
    },
  },
  created() {
    this.getNotifications();
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>

<style>
.ant-collapse-content > .ant-collapse-content-box {
  padding: 0px !important;
}
</style>
